import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import {
  BACKGROUND_THEME_NONE,
  resolveBackgroundTheme,
} from "../constants/backgroundThemes";
import { getLuminance } from "../utils/colorUtils";

const HIDDEN_PATHS = ["/fullscreen-display"];

const BackgroundThemeLayer = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const pattern = resolveBackgroundTheme(theme.backgroundImage);

  if (
    pattern === BACKGROUND_THEME_NONE ||
    HIDDEN_PATHS.some((path) => location.pathname.startsWith(path))
  ) {
    return null;
  }

  const pageColor =
    theme.displayBackgroundColor ||
    theme.backgroundColor ||
    theme.originalBackgroundColor ||
    "#F8F9FA";
  const isDark = getLuminance(pageColor) < 0.45;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0"
      style={{
        opacity: 0.18,
        backgroundColor: isDark ? "#ffffff" : "#1a1a1a",
        WebkitMaskImage: `url(${pattern})`,
        maskImage: `url(${pattern})`,
        WebkitMaskRepeat: "repeat",
        maskRepeat: "repeat",
        WebkitMaskSize: "360px 360px",
        maskSize: "360px 360px",
      }}
    />
  );
};

export default BackgroundThemeLayer;
